(function () {
  'use strict';

  function initDrawer(root) {
    var toggle = root.querySelector(
      '[data-gs-strive-nav-toggle]'
    );

    var drawer = root.querySelector(
      '#gs-strive-nav-drawer'
    );

    if (!toggle || !drawer) return;

    function setOpen(open) {
      toggle.setAttribute(
        'aria-expanded',
        open ? 'true' : 'false'
      );

      toggle.setAttribute(
        'aria-label',
        open ? 'Close menu' : 'Open menu'
      );

      drawer.setAttribute(
        'aria-hidden',
        open ? 'false' : 'true'
      );

      document.body.classList.toggle(
        'gs-strive-nav-open',
        open
      );

      if (open) {
        var firstLink = drawer.querySelector(
          'a, button'
        );

        if (firstLink) {
          firstLink.focus({
            preventScroll: true
          });
        }
      }
    }

    toggle.addEventListener(
      'click',
      function () {
        var isOpen =
          toggle.getAttribute('aria-expanded') ===
          'true';

        setOpen(!isOpen);
      }
    );

    document.addEventListener(
      'keydown',
      function (event) {
        var isOpen =
          toggle.getAttribute('aria-expanded') ===
          'true';

        if (event.key === 'Escape' && isOpen) {
          setOpen(false);

          toggle.focus({
            preventScroll: true
          });
        }
      }
    );

    drawer.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a');

        if (link) {
          setOpen(false);
        }
      }
    );

    var mediaQuery = window.matchMedia(
      '(min-width: 992px)'
    );

    function handleBreakpoint() {
      var isOpen =
        toggle.getAttribute('aria-expanded') ===
        'true';

      if (mediaQuery.matches && isOpen) {
        setOpen(false);
      }
    }

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener(
        'change',
        handleBreakpoint
      );
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(
        handleBreakpoint
      );
    }
  }

  function initScrollBehavior(nav) {
    if (!nav) return;

    var container =
      nav.closest('.shopify-section') || nav;

    var previousY = Math.max(
      window.scrollY,
      0
    );

    var ticking = false;

    function updateNavigation() {
      var currentY = Math.max(
        window.scrollY,
        0
      );

      var scrollingUp =
        currentY < previousY;

      var scrollingDown =
        currentY > previousY;

      var menuIsOpen =
        document.body.classList.contains(
          'gs-strive-nav-open'
        );

      if (
        currentY <= 10 ||
        scrollingUp ||
        menuIsOpen
      ) {
        container.classList.remove(
          'gs-strive-nav--hidden'
        );
      } else if (scrollingDown) {
        container.classList.add(
          'gs-strive-nav--hidden'
        );
      }

      previousY = currentY;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;

        window.requestAnimationFrame(
          updateNavigation
        );

        ticking = true;
      },
      {
        passive: true
      }
    );
  }

  function initializeNavigation() {
    var navigationBars =
      document.querySelectorAll(
        '.gs-strive-nav'
      );

    navigationBars.forEach(
      function (nav) {
        initDrawer(nav);
      }
    );

    initScrollBehavior(
      document.querySelector(
        '.gs-strive-nav'
      )
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeNavigation
    );
  } else {
    initializeNavigation();
  }

  if (
    window.Shopify &&
    Shopify.designMode
  ) {
    document.addEventListener(
      'shopify:section:load',
      function (event) {
        var nav = event.target.querySelector(
          '.gs-strive-nav'
        );

        if (nav) {
          initDrawer(nav);
        }
      }
    );
  }
})();